
import { Injectable } from '@angular/core';
import { Http } from "@angular/http";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CommonService } from '../common.service';

@Injectable()
export class TwitterService {

  public subject: BehaviorSubject<any>;

  constructor(private http: Http, private cs: CommonService) {
    this.subject = new BehaviorSubject({});
  }

  login() {
    this.http.post(this.cs.url + '/twitter/mcam/authorization', {})
      .map(data => data.json())
      .toPromise()
      .then(data => {
        this.cs.openWindows(data);
      });
    setTimeout(() => {
      const data = JSON.parse(localStorage.getItem("twitterdata"));
      this.subject.next(data);
    }, 6000)
  }

  loginSuccess(token: string) {
    this.http.get(this.cs.url + '/twitter/mcam/login/' + token, {})
      .map(data => data.json())
      .toPromise()
      .then(data => {
        localStorage.setItem("twitterdata", JSON.stringify(data));
        this.cs.closeWindows();
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/social/twitter/twitter.service.ts